export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_COLLABORATOR = 'collaborator';
export const USER_ROLE_OPERATOR = 'operator';
export const USER_ROLE_MEMBER = 'member';

export function getUserRoleLabel(role: string) {
  switch (role) {
    case USER_ROLE_ADMIN:
      return 'Administrator';

    case USER_ROLE_OPERATOR:
      return 'Operator';

    case USER_ROLE_COLLABORATOR:
      return 'Collaborator';

    default:
      return 'Member';
  }
}

export const ADMIN_DURATION_CUSTOM = 'custom';
export const ADMIN_DURATION_PERMANENT = 'permanent';

export const ADMIN_DURATION_OPTIONS = [
  { value: ADMIN_DURATION_PERMANENT, label: 'Permanent' },
  { value: '86400', label: '24 hours' },
  { value: '259200', label: '3 days' },
  { value: '604800', label: '7 days' },
  { value: '2592000', label: '30 days' },
  { value: '7776000', label: '90 days' },
  { value: ADMIN_DURATION_CUSTOM, label: 'Custom' },
];

export const ADMIN_DURATION_UNIT_OPTIONS = [
  { value: 'hours', label: 'Hours' },
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
];

export const UNIT_TO_SECONDS: Record<string, number> = {
  hours: 3600,
  days: 86400,
  weeks: 604800,
};

export function secondsToPreset(seconds: number | null | undefined): string {
  if (!seconds) return ADMIN_DURATION_PERMANENT;
  const match = ADMIN_DURATION_OPTIONS.find((o) => o.value === String(seconds));
  return match ? match.value : ADMIN_DURATION_CUSTOM;
}

export const USER_ROLE_OPTIONS = [
  {
    value: USER_ROLE_ADMIN,
    title: getUserRoleLabel(USER_ROLE_ADMIN),
    description:
      'User will be automatically granted permission to view and modify all resources in the organization.',
  },
  {
    value: USER_ROLE_OPERATOR,
    title: getUserRoleLabel(USER_ROLE_OPERATOR),
    description:
      'User will be automatically granted permission to view all resource in the organization and can activate/pause resources that have a status. They will not be able to make any other modifications to any resource.',
  },
  {
    value: USER_ROLE_COLLABORATOR,
    title: getUserRoleLabel(USER_ROLE_COLLABORATOR),
    description:
      'User will be automatically granted permission to view all resources in the organization but cannot make any modifications to them.',
  },
  {
    value: USER_ROLE_MEMBER,
    title: getUserRoleLabel(USER_ROLE_MEMBER),
    description:
      'User will not be granted any automatic permission to access resources they did not create.',
  },
];
